var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTree2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 32 32",
    id: "svg1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer6",
    transform: "translate(-64,-64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3-8-4",
    transform: "translate(0,64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1-3-58-6-8-6-6-5-50-2-9-8-6-8",
    style: {
      fill: "#a5a664",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.999997,
      strokeLinejoin: "round"
    },
    d: "m 73.27456,22.730069 c 0.18868,0.188679 3.63271,-0.443079 4.52831,-1.886792 0.3653,-0.588883 0.1895,-1.552919 -0.25354,-2.121173 l -0.68986,0.68986 v 1.431312 c 0,0.10421 -0.0845,0.188678 -0.1887,0.188678 -0.10422,0 -0.18868,-0.08449 -0.18868,-0.188678 v -1.053954 l -0.7547,0.754716 v 0.67512 c 0,0.10421 -0.0845,0.18868 -0.1887,0.18868 -0.10422,0 -0.18868,-0.08446 -0.18868,-0.18868 v -0.297757 l -0.80999,0.809993 c -0.0737,0.07366 -0.19313,0.07366 -0.26681,0 -0.0737,-0.07368 -0.0737,-0.19312 0,-0.266802 l 0.81,-0.809995 h -0.30181 -0.002 c -0.24805,-0.0037 -0.24805,-0.373854 0,-0.377363 h 0.002 0.67917 l 0.75474,-0.754714 h -1.05396 c -0.10422,0 -0.18868,-0.08449 -0.18868,-0.18868 0,-0.10421 0.0845,-0.188679 0.18868,-0.188679 h 1.43132 l 0.69087,-0.690872 c -0.57017,-0.45238 -1.52127,-0.622035 -2.12218,-0.252526 -1.44088,0.88601 -2.07548,4.339626 -1.8868,4.528306 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1-3-58-6-8-6-6-5-5-0-1-0-2-82-9-0-9-1-3",
    style: {
      fill: "#a5a664",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.999997,
      strokeLinejoin: "round"
    },
    d: "m 90.72544,20.730069 c -0.18868,0.188679 -3.63271,-0.443079 -4.52831,-1.886793 -0.3653,-0.588883 -0.1895,-1.552919 0.25354,-2.121172 l 0.68986,0.68986 v 1.431312 c 0,0.10421 0.0845,0.188678 0.1887,0.188678 0.10422,0 0.18868,-0.08449 0.18868,-0.188678 v -1.053954 l 0.7547,0.754716 v 0.67512 c 0,0.10421 0.0845,0.18868 0.1887,0.18868 0.10422,0 0.18868,-0.08446 0.18868,-0.18868 v -0.297757 l 0.80999,0.809993 c 0.0737,0.07366 0.19313,0.07366 0.26681,0 0.0737,-0.07368 0.0737,-0.19312 0,-0.266802 l -0.81,-0.809995 h 0.30181 0.002 c 0.24805,-0.0037 0.24805,-0.373854 0,-0.377363 h -0.002 -0.67917 L 87.78469,17.52252 h 1.05396 c 0.10422,0 0.18869,-0.08449 0.18869,-0.18868 0,-0.10421 -0.0845,-0.188679 -0.18869,-0.188679 h -1.43132 l -0.69087,-0.690872 c 0.57017,-0.45238 1.52127,-0.622035 2.12218,-0.252526 1.44088,0.88601 2.07548,4.339626 1.8868,4.528306 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12-3-3-1-8-9-5",
    style: {
      color: "#000000",
      fill: "#a5a664",
      fillOpacity: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "m 84,13.5 c -0.235702,0 -0.40749,0.283211 -0.5,0.5 -0.1922,0.450401 0.16095,1.018353 -0.03125,1.468754 -0.655071,1.535093 -2.060088,2.912558 -3.540527,3.540527 -0.63906,0.271075 -0.984035,-0.998124 -1.574707,-1.362797 C 78.24498,17.579476 78.127554,17.5 78,17.5 c -0.127554,0 -0.282657,0.04042 -0.353516,0.146484 -0.130923,0.195967 -0.07949,0.485164 0,0.707032 C 77.886111,19.022356 78.760373,19.33116 79,20 c 0.899412,2.510412 -1.020489,5.536321 0,8 0.180399,0.435521 0.528595,1 1,1 0.471405,0 0.819601,-0.564479 1,-1 1.012517,-2.444431 -1.012517,-5.493069 0,-7.9375 0.637033,-1.537933 3,-3.33102 3.53125,-3.53125 C 84.989478,16.358542 85.5496,16.692199 86,16.5 86.216789,16.40749 86.5,16.235702 86.5,16 86.5,15.764298 86.216789,15.59251 86,15.5 85.5496,15.307801 84.877516,15.815016 84.53125,15.46875 84.184984,15.122484 84.692199,14.4504 84.5,14 84.40749,13.783211 84.235702,13.5 84,13.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#7d451b",
      fillOpacity: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "m 76,26 a 2,2 0 0 0 -2,2 2,2 0 0 0 2,2 h 8 a 2,2 0 0 0 2,-2 2,2 0 0 0 -2,-2 z",
    id: "path1-04-9-9-2-2-6-0"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter"
    },
    id: "rect24-3-5-0",
    width: 32,
    height: 32,
    x: 64,
    y: 0,
    rx: 0,
    ry: 2.7755576e-17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTree2);
export default __webpack_public_path__ + "static/media/icon_tree2.ab1e30318335ac601e22403936f5a0ab.svg";
export { ForwardRef as ReactComponent };